import { CLICK_IDS } from '@sunflower-games/analytics-events';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'react-use';

import coinsHeader from '../../../assets/coins-header.png';
import Button from '../../../components/buttons/Button';
import { DialogBox } from '../../../components/Dialog/DialogBox';
import { DialogContent } from '../../../components/Dialog/DialogContent';
import { DialogHeader } from '../../../components/Dialog/DialogHeader';
import { analytics } from '../../../services/analytics';
import { useStores } from '../../../stores/useStores';

import styles from './PocSuccessNotification.module.scss';

export const PocSuccessNotification = observer(function PocSuccessNotification() {
  const { t } = useTranslation();
  const { pocStore, portalStore } = useStores();

  const handleClose = () => {
    void analytics.sendEvent('automatic_poc', {
      step: 'automatic_poc_success',
      event_action: 'click',
      click_id: CLICK_IDS.POC.SUCCESS_NTF,
      triggered_by: 'click',
    });

    portalStore.closePortal();
  };

  useEffectOnce(() => {
    void pocStore.noticePocSuccess();
  });

  return (
    <DialogBox>
      <DialogHeader
        title={
          <>
            <img alt={t('poc.coinsHeader')} className={styles.coinsHeader} src={coinsHeader} />
            {t('poc.verificationSuccessful')}
          </>
        }
        onClose={handleClose}
      />
      <DialogContent>
        <p className={styles.prompt}>
          {t('poc.cardApproved', { cardNumberEnding: pocStore.successNotice?.cardNumberEnding || '????' })}
        </p>
        <Button btnType="main" className={styles.awesomeBtn} onClick={handleClose}>
          {t('buttons.awesome')}
        </Button>
      </DialogContent>
    </DialogBox>
  );
});
